export const API_URL = process.env.NX_ENVIRONMENT_API_URL;
export const PROCESSING_API_URL = process.env.NX_PROCESSING_API_URL;
export const licenseKeyHeader = 'x-license-key';
export const PAYLOAD_CHUNK_SIZE = 50;
